<template>
  <div>
    <div class="uk-slider-container-offset slider-container" uk-slider="finite: true" v-if="homeSummaryList.length > 0">
      <p class="title">There are {{homeSummaryList.length}} similar homes</p>
      <div class="uk-slider-items r-columns">
        <div class="r-column"></div>
        <div class="r-column is-narrow" v-for="(homeSummary, index) in homeSummaryList" :key="index">
          <a @click="selectHome(homeSummary)"
             :class="{'is-active': activeHomeDetail && activeHomeDetail.cpidstring === homeSummary.cpidstring}">
            <app-home-card v-bind:homeSummary="homeSummary" v-bind:triggerSelect="false" v-on:homeSelected="selectHome($event)"></app-home-card>
          </a>
        </div>
        <div class="r-column"></div>  
      </div>
      <a href="#" class="slidenav-buttons slidenav-left uk-visible@m" uk-slidenav-previous uk-slider-item="previous"></a>
      <a href="#" class="slidenav-buttons slidenav-right uk-visible@m" uk-slidenav-next uk-slider-item="next"></a>
    </div>
    <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
  </div>
</template>

<script>
import HomeCard from "@/components/journey/home/HomeCard";

export default {
  name: 'similar-homes',
  props: {
    activeHomeDetail: {
      type: Object
    }
  },
  components: {
    'app-home-card': HomeCard,
  },
  mounted() {
    if (this.activeHomeDetail) {
      this.homeSummaryList = this.$store.getters.homeSummary.filter(item => {
        return item.noofbedrooms === this.activeHomeDetail.noofbedrooms && item.ownername === this.activeHomeDetail.ownername
      })
    }
  },
  data() {
    return {
      homeSummaryList: []
    }
  },
  watch: {
  },
  methods: {
    selectHome: function (homesummary) {
      this.$store.dispatch('productTracking', {product: homesummary, page: 'home-design'})
      this.$emit('similarhome', homesummary)
    },

    viewHome: function () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/home/SimilarHomes.vue